import { useHistory } from 'react-router-dom'

import { Auth } from '@scouts/auth'
import { ButtonLink, Line } from '@taxfix/scouts-ui'

import { PATH_LOGIN } from '@/constants'

const Footer = () => {
    const history = useHistory()

    return <ButtonLink onClick={() => history.push(PATH_LOGIN)}>Back</ButtonLink>
}

export const ResetPassword = () => {
    return (
        <Auth.LockscreenLayout title="Reset your password" footer={<Footer />}>
            <Line textAlign="center">We'll send you an email with instructions to reset your password</Line>
            <Auth.ResetPasswordForm />
        </Auth.LockscreenLayout>
    )
}
